module.exports = __webpack_public_path__ + "img/call-chart.b24c4d5a.svg";